import { render } from "./BlackResearchReport.vue?vue&type=template&id=0ce216b1&scoped=true"
import script from "./BlackResearchReport.vue?vue&type=script&lang=js"
export * from "./BlackResearchReport.vue?vue&type=script&lang=js"

import "./BlackResearchReport.vue?vue&type=style&index=0&id=0ce216b1&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce216b1"]])

export default __exports__